"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBar = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var nav_bar_item_1 = require("./nav-bar-item");
var create_chained_function_1 = __importDefault(require("../util/create-chained-function"));
var dom_helpers_1 = require("../util/dom-helpers");
var angle_right_1 = __importDefault(require("adp-react-icons/lib/fa/angle-right"));
var angle_left_1 = __importDefault(require("adp-react-icons/lib/fa/angle-left"));
var warning_1 = __importDefault(require("../util/warning"));
var didWarnDeprecated = false;
var SCREEN_XS_MAX = 480;
var NavBar = /** @class */function (_super) {
  __extends(NavBar, _super);
  function NavBar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      scrollPosition: 0,
      canScrollLeft: false,
      canScrollRight: false,
      stretch: _this.props.stretch,
      navBarWidth: 0
    };
    _this._itemElements = {};
    _this.updateLayout = function (options) {
      setTimeout(function () {
        var _a;
        var activeIndex = _this.props.activeIndex;
        var scrollPosition = _this.state.scrollPosition;
        var prevNavBarWidth = _this.state.navBarWidth;
        var navBarWidth = dom_helpers_1.width(react_dom_1.default.findDOMNode(_this._items));
        var stretch = _this.props.stretch && (prevNavBarWidth || navBarWidth) < SCREEN_XS_MAX;
        var activeItem = (_a = react_dom_1.default.findDOMNode(_this._items)) === null || _a === void 0 ? void 0 : _a.childNodes[activeIndex];
        var navBarItemsWidth = _this.getNavBarItemsWidth();
        var minPos = Math.min(0, navBarWidth - navBarItemsWidth);
        var activePos = dom_helpers_1.position(activeItem, undefined);
        var containerPos = dom_helpers_1.position(react_dom_1.default.findDOMNode(_this._container), undefined);
        if (options) {
          if (typeof options.scrollPosition === 'number') {
            scrollPosition = options.scrollPosition;
          } else if (options.showActiveTab) {
            var leftEdge = activePos.left + containerPos.left;
            var rightEdge = leftEdge + activePos.width;
            if (rightEdge > containerPos.width) {
              // scroll left
              scrollPosition = containerPos.width - activePos.left - activePos.width;
            } else if (leftEdge < 0) {
              // scroll right
              scrollPosition = -activePos.left;
            }
          }
        }
        if (stretch) {
          scrollPosition = -activePos.left;
        } else if (scrollPosition < minPos) {
          scrollPosition = minPos;
        } else if (scrollPosition > 0) {
          scrollPosition = 0;
        }
        var canScrollLeft = scrollPosition < 0;
        var canScrollRight = navBarItemsWidth + scrollPosition > navBarWidth;
        _this.setState({
          scrollPosition: scrollPosition,
          navBarWidth: navBarWidth,
          canScrollLeft: canScrollLeft,
          canScrollRight: canScrollRight,
          stretch: stretch
        });
      }, 0);
    };
    _this.getNavBarItemsWidth = function () {
      var _a;
      var items = (_a = react_dom_1.default.findDOMNode(_this._items)) === null || _a === void 0 ? void 0 : _a.childNodes;
      var width = 0;
      for (var i = 0; i < items.length; i++) {
        width += dom_helpers_1.width(items[i]);
      }
      return width;
    };
    _this.handleResize = function () {
      _this.updateLayout({
        showActiveTab: true
      });
    };
    _this.handleOnItemClick = function (index) {
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(index);
      }
      _this.updateLayout({
        showActiveTab: true
      });
    };
    _this.parseNavBarItems = function () {
      var navBarItems = [];
      react_1.default.Children.forEach(_this.props.children, function (item) {
        if (item.type === nav_bar_item_1.NavBarItem) {
          navBarItems.push(item);
        }
      });
      return navBarItems;
    };
    _this.scrollRight = function () {
      var activeIndex = _this.props.activeIndex;
      if (_this.state.stretch) {
        if (_this._itemElements[activeIndex + 1]) {
          _this._itemElements[activeIndex + 1].props.onClick();
        }
      } else {
        _this.updateLayout({
          scrollPosition: _this.state.scrollPosition - 150
        });
      }
    };
    _this.scrollLeft = function () {
      var activeIndex = _this.props.activeIndex;
      if (_this.state.stretch) {
        if (_this._itemElements[activeIndex - 1]) {
          _this._itemElements[activeIndex - 1].props.onClick();
        }
      } else {
        _this.updateLayout({
          scrollPosition: _this.state.scrollPosition + 150
        });
      }
    };
    _this.renderNavBarItems = function (items) {
      return items.map(function (item, idx) {
        var onClick = create_chained_function_1.default(item.props.onClick, _this.handleOnItemClick.bind(_this, idx));
        return react_1.default.cloneElement(item, {
          key: idx,
          active: _this.props.activeIndex === idx,
          onClick: onClick,
          ref: function ref(itm) {
            return _this._itemElements[idx] = itm;
          }
        });
      });
    };
    return _this;
  }
  NavBar.prototype.componentDidMount = function () {
    this.updateLayout();
    window.addEventListener('resize', this.handleResize);
  };
  NavBar.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.handleResize);
  };
  NavBar.prototype.render = function () {
    var _a;
    var _this = this;
    var className = this.props.className;
    var customProps = _1.omit(this.props, Object.keys(NavBar.propTypes));
    var rootClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('nav-bar')] = true, _a[vdl_prefix_1.vdlPrefix('nav-bar--xs')] = this.state.stretch, _a);
    var navBarItems = this.parseNavBarItems();
    if (!didWarnDeprecated) {
      warning_1.default(false, 'adp-react-components: NavBar component is deprecated. Please use SecondaryNav instead.');
      didWarnDeprecated = true;
    }
    return react_1.default.createElement("header", __assign({}, customProps, {
      className: classnames_1.classNames(className, rootClasses)
    }), react_1.default.createElement("div", {
      ref: function ref(c) {
        _this._container = c;
      },
      className: vdl_prefix_1.vdlPrefix('nav-bar__container'),
      style: {
        left: this.state.scrollPosition
      }
    }, react_1.default.createElement("ul", {
      ref: function ref(c) {
        _this._items = c;
      },
      className: vdl_prefix_1.vdlPrefix('nav-bar__items')
    }, this.renderNavBarItems(navBarItems))), this.state.canScrollLeft && react_1.default.createElement("div", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('nav-bar__scroll'), vdl_prefix_1.vdlPrefix('nav-bar__scroll--prev')),
      onClick: this.scrollLeft
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('nav-bar__scroll__icon')
    }, react_1.default.createElement(angle_left_1.default, null)), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('nav-bar__scroll__fade')
    })), this.state.canScrollRight && react_1.default.createElement("div", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('nav-bar__scroll'), vdl_prefix_1.vdlPrefix('nav-bar__scroll--next')),
      onClick: this.scrollRight
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('nav-bar__scroll__fade')
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('nav-bar__scroll__icon')
    }, react_1.default.createElement(angle_right_1.default, null))));
  };
  NavBar.propTypes = {
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    onChange: prop_types_1.default.func,
    activeIndex: prop_types_1.default.number,
    stretch: prop_types_1.default.bool
  };
  NavBar.defaultProps = {
    activeIndex: 0,
    stretch: false
  };
  return NavBar;
}(react_1.default.Component);
exports.NavBar = NavBar;